// Phone-only "group & minimise": every titled card (admin cards, dashboard panels, service/plan blocks)
// becomes a tap-to-open group, so long pages stay short instead of stacking into one tall column.
// Pure DOM + data-attributes (React never touches them); desktop/tablet are left exactly as they were.
const CARD = ".ac-card, .bay-panel, .xs-card, .ap-card, .apl-card";
const HEAD = ".ac-card-head, .bay-sec-head, .xs-card-head, .ap-card-head, .apl-card-head";
const SKIP = "a,button,input,select,textarea,label,[role=button],[role=tab]";
const mq = () => window.matchMedia("(max-width: 767px)");

function enhance(root) {
  const cards = root.querySelectorAll ? root.querySelectorAll(CARD) : [];
  cards.forEach((card) => {
    if (card.dataset.mg) return;
    const head = Array.from(card.children).find((c) => c.matches(HEAD));
    if (!head) return;                                    // untitled blocks stay open
    if (card.querySelector(":scope > .ac-table-wrap, :scope > form") && !head) return;
    card.dataset.mg = "1";
    head.dataset.mgHead = "1";
    head.setAttribute("role", "button"); head.setAttribute("tabindex", "0");
    // first group on a screen opens by itself; the rest start minimised
    const first = !card.parentElement?.querySelector(":scope > [data-mg-open]");
    card.dataset.mgOpen = first ? "true" : "false";
    head.setAttribute("aria-expanded", first ? "true" : "false");
  });
}

// Tables: copy each column title onto its cells (data-label) so a row can be shown as a clean card on phones.
function labelTables(root) {
  const tables = root.querySelectorAll ? root.querySelectorAll(".navi-table-scroll table, .ac-table-wrap table, table.ac-table") : [];
  tables.forEach((t) => {
    const heads = Array.from(t.querySelectorAll("thead th")).map((h) => (h.textContent || "").trim());
    if (!heads.length) return;
    t.dataset.mgTable = "1";
    t.querySelectorAll("tbody tr").forEach((tr) => {
      const cells = Array.from(tr.children);
      if (cells.length === 1 && cells[0].colSpan > 1) { tr.dataset.mgEmpty = "1"; return; }
      cells.forEach((td, i) => { if (heads[i] && td.dataset.label !== heads[i]) td.dataset.label = heads[i]; });
    });
  });
}

function toggle(head) {
  const card = head.parentElement; if (!card?.dataset.mg) return;
  const open = card.dataset.mgOpen !== "true";
  card.dataset.mgOpen = open ? "true" : "false";
  head.setAttribute("aria-expanded", open ? "true" : "false");
  if (open) card.scrollIntoView?.({ block: "nearest", behavior: "smooth" });
}

export function initMobileGroups() {
  if (typeof window === "undefined" || window.__naviMg) return; window.__naviMg = true;
  const m = mq(); let raf = 0;
  const run = () => { raf = 0; document.documentElement.dataset.mgOn = m.matches ? "1" : "0"; if (m.matches) { enhance(document); labelTables(document); } };
  const queue = () => { if (!raf) raf = requestAnimationFrame(run); };
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
  m.addEventListener?.("change", queue); queue();
  document.addEventListener("click", (e) => {
    if (!m.matches) return;
    const head = e.target.closest?.("[data-mg-head]"); if (!head || e.target.closest(SKIP)) return;
    toggle(head);
  });
  document.addEventListener("keydown", (e) => {
    if (!m.matches || (e.key !== "Enter" && e.key !== " ")) return;
    const head = e.target.closest?.("[data-mg-head]"); if (head && e.target === head) { e.preventDefault(); toggle(head); }
  });
}
